import imageUrlBuilder from "@sanity/image-url"
import client from "../../client"

export const cn = (...classes) => classes.join(" ")

export const contrastChecker = (rgb) =>
  Math.round(
    (parseInt(rgb[0]) * 299 + parseInt(rgb[1]) * 587 + parseInt(rgb[2]) * 114) /
      1000
  )

export function urlFor(source) {
  const builder = imageUrlBuilder(client)
  return builder.image(source)
}

export function slugify(string) {
  const a =
    "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;"
  const b =
    "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------"
  const p = new RegExp(a.split("").join("|"), "g")

  return string
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, "-and-") // Replace & with 'and'
    .replace(/[^\w\-]+/g, "") // Remove all non-word characters
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, "") // Trim - from end of text
}

export const leadingZeros = (number) => ("0" + number).slice(-2)

export const getTimestamp = (date, withTime) => {
  if (!(date instanceof Date)) {
    date = new Date(date)
  }
  const time = ` kl. ${leadingZeros(date.getHours())}:${leadingZeros(
    date.getMinutes()
  )}`
  const formattedDate = `${leadingZeros(date.getDate())}.${leadingZeros(
    date.getMonth() + 1
  )}.${date.getFullYear()}`

  return withTime ? formattedDate + time : formattedDate
}
